// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotoGalleryMobile_root__M0dHi","button":"PhotoGalleryMobile_button__UwRtl","actions":"PhotoGalleryMobile_actions__Tuu9P"};